var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: { title: "", visible: _vm.dialogShow },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        }
      }
    },
    [
      _vm.showSelectData
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "popover",
                  attrs: {
                    model: _vm.searchData,
                    rules: _vm.rules,
                    "label-position": "left"
                  }
                },
                [
                  _vm.rawData.game_show_type == 1 && _vm.isProduct
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem",
                          attrs: { label: "产品", prop: "special_product_id" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "",
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择产品"
                              },
                              on: { change: _vm.productChange },
                              model: {
                                value: _vm.searchData.special_product_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchData,
                                    "special_product_id",
                                    $$v
                                  )
                                },
                                expression: "searchData.special_product_id"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "17px" },
                                  attrs: { size: "small" },
                                  on: { click: _vm.toggleSelectAll }
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "12px",
                                    "margin-bottom": "5px"
                                  },
                                  attrs: { size: "small" },
                                  on: { click: _vm.toggleInvertSelect }
                                },
                                [_vm._v("反选")]
                              ),
                              _vm._l(_vm.productsList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { label: "广告渠道", prop: "ad_channel" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择广告渠道"
                          },
                          on: { change: _vm.advChannelchangeMore },
                          model: {
                            value: _vm.searchData.ad_channel,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "ad_channel", $$v)
                            },
                            expression: "searchData.ad_channel"
                          }
                        },
                        _vm._l(_vm.advchannels, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.adv_platform_name,
                              value: item.adv_platform_mark
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { label: "广告位置", prop: "ad_placement" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择广告位置"
                          },
                          model: {
                            value: _vm.searchData.ad_placement,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "ad_placement", $$v)
                            },
                            expression: "searchData.ad_placement"
                          }
                        },
                        _vm._l(_vm.advLocation, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.adv_place_name,
                              value: item.adv_place_mark
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: {
                        click: function($event) {
                          return _vm.dataSelect()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "chat-container" },
            [
              _c(
                "div",
                { staticClass: "chat-info-header" },
                [
                  _vm.activeChatConfig
                    ? [
                        _c(
                          "div",
                          { staticClass: "info-group" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-start",
                                  width: "250",
                                  trigger: "hover"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "info-detail-popover" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "popover-title" },
                                      [_vm._v("已选产品")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tag-container" },
                                      _vm._l(
                                        _vm.getNamesArray(
                                          _vm.productAllList,
                                          _vm.activeChatConfig.game_id,
                                          "product"
                                        ),
                                        function(name) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: name,
                                              attrs: {
                                                size: "mini",
                                                type: "info"
                                              }
                                            },
                                            [_vm._v(" " + _vm._s(name) + " ")]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-tag",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("产品:")
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNames(
                                            _vm.productAllList,
                                            _vm.activeChatConfig.game_id,
                                            "product"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm.formatNames(
                          _vm.advchannels,
                          _vm.activeChatConfig.ad_channel,
                          "ad_channel"
                        )
                          ? _c(
                              "div",
                              { staticClass: "info-group" },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom-start",
                                      width: "280",
                                      trigger: "hover"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "info-detail-popover" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "popover-title" },
                                          [_vm._v("已选渠道")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "tag-container" },
                                          _vm._l(
                                            _vm.getNamesArray(
                                              _vm.advchannels,
                                              _vm.activeChatConfig.ad_channel,
                                              "ad_channel"
                                            ),
                                            function(name) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: name,
                                                  attrs: { size: "mini" }
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(name) + " "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "info-tag",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("渠道:")
                                        ]),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNames(
                                                _vm.advchannels,
                                                _vm.activeChatConfig.ad_channel,
                                                "ad_channel"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.formatNames(
                          _vm.advLocation,
                          _vm.activeChatConfig.ad_placement,
                          "ad_placement"
                        )
                          ? _c(
                              "div",
                              { staticClass: "info-group" },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom-start",
                                      width: "280",
                                      trigger: "hover"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "info-detail-popover" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "popover-title" },
                                          [_vm._v("已选位置")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "tag-container" },
                                          _vm._l(
                                            _vm.getNamesArray(
                                              _vm.advLocation,
                                              _vm.activeChatConfig.ad_placement,
                                              "ad_placement"
                                            ),
                                            function(name) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: name,
                                                  attrs: {
                                                    size: "mini",
                                                    type: "success"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(name) + " "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "info-tag",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("位置:")
                                        ]),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNames(
                                                _vm.advLocation,
                                                _vm.activeChatConfig
                                                  .ad_placement,
                                                "ad_placement"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c(
                "el-container",
                {
                  staticStyle: {
                    height: "100%",
                    border: "1px solid #eee",
                    overflow: "hidden"
                  }
                },
                [
                  _c(
                    "el-aside",
                    {
                      staticClass: "aside-container",
                      attrs: { width: "260px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            padding: "15px 15px 0"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "搜索历史问题...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                              size: "small"
                            },
                            model: {
                              value: _vm.keyword,
                              callback: function($$v) {
                                _vm.keyword = $$v
                              },
                              expression: "keyword"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: {
                                type: "primary",
                                loading: _vm.reqLoading,
                                size: "small"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.searchHistoryData()
                                }
                              }
                            },
                            [_vm._v("搜索")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "aside-header" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { type: "primary", icon: "el-icon-plus" },
                              on: { click: _vm.startNewChat }
                            },
                            [_vm._v("开始新的聊天")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "margin-bottom": "10px",
                            padding: "0 20px"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#f56c6c", padding: "0" },
                              attrs: {
                                type: "text",
                                icon: "el-icon-delete",
                                disabled: _vm.selectedIds.length == 0
                              },
                              on: { click: _vm.deleteChat }
                            },
                            [
                              _vm._v(
                                " 删除(" + _vm._s(_vm.selectedIds.length) + ") "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "menu-scroll-wrap" },
                        [
                          _c(
                            "el-menu",
                            {
                              attrs: { "default-active": _vm.activeThreadId },
                              on: { select: _vm.handleSelect }
                            },
                            _vm._l(_vm.chatHistory, function(chat) {
                              return _c(
                                "el-menu-item",
                                {
                                  key: chat.thread_id,
                                  attrs: { index: chat.thread_id }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "menu-item-content" },
                                    [
                                      _c("el-checkbox", {
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: {
                                          value: _vm.selectedIds.includes(
                                            chat.thread_id
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.toggleSelect(
                                              chat.thread_id
                                            )
                                          }
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      }),
                                      _c("div", { staticClass: "text-wrap" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "title-row",
                                            attrs: { title: chat.title }
                                          },
                                          [_vm._v(_vm._s(chat.title))]
                                        ),
                                        _c("div", { staticClass: "time-row" }, [
                                          _vm._v(_vm._s(chat.created_at))
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c("el-main", [
                    _c("div", { staticClass: "chat-main" }, [
                      _c(
                        "div",
                        { staticClass: "message-list" },
                        _vm._l(_vm.currentMessages, function(msg, index) {
                          return _c(
                            "div",
                            { key: index, class: ["msg-item", msg.role] },
                            [
                              msg.role === "user"
                                ? _c("div", [
                                    msg.send_datetime
                                      ? _c("div", { staticClass: "msg-time" }, [
                                          _vm._v(_vm._s(msg.send_datetime))
                                        ])
                                      : _vm._e(),
                                    _c("div", { staticClass: "user-msg" }, [
                                      _vm._v(_vm._s(msg.content))
                                    ])
                                  ])
                                : _vm._e(),
                              msg.role === "ai"
                                ? _c("div", { staticClass: "ai-msg-box" }, [
                                    msg.done_datetime
                                      ? _c("div", { staticClass: "msg-time" }, [
                                          _vm._v(_vm._s(msg.done_datetime))
                                        ])
                                      : _vm._e(),
                                    msg.reasoning || msg.message
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "reasoning-container",
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "column"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "reasoning-header"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "reasoning-label"
                                                  },
                                                  [_vm._v("思考过程")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      icon: msg.isReasoningCollapsed
                                                        ? "el-icon-arrow-down"
                                                        : "el-icon-arrow-up"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        msg.isReasoningCollapsed = !msg.isReasoningCollapsed
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          msg.isReasoningCollapsed
                                                            ? "展开"
                                                            : "折叠"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !msg.isReasoningCollapsed,
                                                    expression:
                                                      "!msg.isReasoningCollapsed"
                                                  }
                                                ],
                                                staticClass: "reasoning-text",
                                                style: {
                                                  order:
                                                    msg.firstAppeared ===
                                                    "reasoning"
                                                      ? 2
                                                      : 1
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(msg.reasoning) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !msg.isReasoningCollapsed,
                                                    expression:
                                                      "!msg.isReasoningCollapsed"
                                                  }
                                                ],
                                                staticClass: "reasoning-text",
                                                style: {
                                                  order:
                                                    msg.firstAppeared ===
                                                    "message"
                                                      ? 2
                                                      : 1
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(msg.message) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    msg.done
                                      ? _c("div", {
                                          staticClass:
                                            "done-text markdown-body",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.renderMarkdown(msg.done)
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    msg.chartOption
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "chart-scroll-wrapper"
                                          },
                                          [
                                            _c("echartsContainer", {
                                              attrs: { option: msg.chartOption }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    msg.error
                                      ? _c(
                                          "div",
                                          { staticClass: "done-text" },
                                          [_vm._v(_vm._s(msg.error))]
                                        )
                                      : _vm._e(),
                                    msg.loading
                                      ? _c(
                                          "div",
                                          { staticClass: "loading-dots" },
                                          [_c("span"), _c("span"), _c("span")]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "input-area" },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入内容..." },
                              on: { input: _vm.scrollToBottom },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleButtonClick($event)
                                }
                              },
                              model: {
                                value: _vm.inputContent,
                                callback: function($$v) {
                                  _vm.inputContent = $$v
                                },
                                expression: "inputContent"
                              }
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: _vm.loading
                                    ? "el-icon-video-pause"
                                    : "el-icon-s-promotion",
                                  title: _vm.loading ? "停止生成" : "发送"
                                },
                                on: { click: _vm.handleButtonClick },
                                slot: "append"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }